import { StatusColor, SHIFT_STATUS_COLORS } from "./constants";

export const getShiftStatusColor = (
  status: "Completed" | "Incomplete" | "Checked-in" | "Registered",
  occupancy?: "Full" | "Partial" | "None"
): StatusColor => {
  if (status === "Completed" || status === "Incomplete") {
    return SHIFT_STATUS_COLORS[status] as StatusColor;
  }
  if (occupancy && (status === "Checked-in" || status === "Registered")) {
    return (SHIFT_STATUS_COLORS[status] as Record<string, StatusColor>)[
      occupancy
    ];
  }
  throw new Error("Invalid status or occupancy");
};
